import { observer } from 'mobx-react-lite'
import { Typography } from '@mui/material'
import { AppBox } from 'src/component/common/analog/molecule/AppBox'
import { MAX_SKILL_HINT_LENGTH, MAX_SKILL_NAME_LENGTH } from 'src/feature/dashboard/constants/skill-assessment-constants'
import { CharacterCountedTextField } from '../molecule/CharacterCountedTextField'

type SkillHeaderProps = {
  isEditing: boolean
  skillName: string
  skillHint: string
  onSkillNameChange: (value: string) => void
  onSkillHintChange: (value: string) => void
}

/**
 * Component for displaying and editing skill name and description/hint
 */
export const SkillHeader = observer((props: SkillHeaderProps) => {
  const { isEditing, skillName, skillHint, onSkillNameChange, onSkillHintChange } = props

  return (
    <AppBox flexDirection='column' justifyContent='center' gap={5} sx={{ width: '100%' }}>
      {isEditing ? (
        <>
          <CharacterCountedTextField
            fullWidth
            value={skillName}
            onChange={e => onSkillNameChange(e.target.value)}
            variant="outlined"
            size="small"
            maxLength={MAX_SKILL_NAME_LENGTH}
          />
          <CharacterCountedTextField
            fullWidth
            multiline
            minRows={2}
            value={skillHint}
            onChange={e => onSkillHintChange(e.target.value)}
            variant="outlined"
            size="small"
            maxLength={MAX_SKILL_HINT_LENGTH}
          />
        </>
      ) : (
        <>
          <Typography variant='h5' m={0}>
            {skillName}
          </Typography>
          <Typography variant='body2' sx={{ color: 'text.secondary' }}>
            {skillHint}
          </Typography>
        </>
      )}
    </AppBox>
  )
})
